import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DmSignal from '../../UI/DmSignal/DmSignal';
import DmLink from '../../UI/DmLink/DmLink'; 
import PressureSensorPlc from '../../UI/PressureSensorPlc/PressureSensorPlc';
import PressureSensorPch from '../../UI/PressureSensorPch/PressureSensorPch';
import PrepDataPlc from './PrepDataPlc/PrepDataPlc';
import PrepDataPch from './PrepDataPch/PrepDataPch';
import { checkBit, checkConnectionSlave, formatParametr } from '../../Utils/Functions';
import { checkDeviceLink } from '../../Utils/DateFormatter';
import './RsInfo.css';

export default function RsInfo() {

    const parameter = useSelector((state) => state.dmimei?.data[0]);
    const [rsInfo, setRsInfo ] = useState({
        typeRsDevice: '...',
        signalValue: '...',
        param_last_date: 0,
        pressure: '...'
    });
    
    //проверку входных данных
    useEffect(() => {
        setRsInfo({
        typeRsDevice: parameter?.typeRsDevice_name || '...',
        signalValue: parameter?.Sig_Value || '...',
        param_last_date: parameter?.param_last_date || 0,
        pressure: parameter?.param1 || 0
        })
    },[parameter]);
   
    const browserTime = new Date();
    const islink = checkDeviceLink(rsInfo?.param_last_date, browserTime) ?  'Online' : 'Offline';
    const isConnectionLost = checkConnectionSlave(parameter);
   
    let pSensor;
    if(rsInfo.typeRsDevice==='PLC') {
        pSensor=checkBit(parameter?.param4,15) ? 'Исправен' : 'Не исправен';
    }

    return(
        <div className='rsCardInfo'> 
            <div className='rsCardInfoHeader'>
            <div className='rsCardInfoHeadP'> 
            {!isConnectionLost && rsInfo.typeRsDevice==='PLC' && 
                <PressureSensorPlc pressure={formatParametr(parameter?.param1, 1, 'Бар')}
                fault={checkBit(parameter?.param4,15)}
                islink={islink} />}

            {!isConnectionLost &&
                ['PCH_Instart', 'PCH_ESQ', 'PCH_ATV'].includes(rsInfo.typeRsDevice) &&
                    <PressureSensorPch 
                            percent={parameter?.param1}
                            pmax={parameter?.PMax}
                            islink={islink} 
                        />}
            </div>
                <div className='rsInfoSignalLink'> 
                <DmSignal signalValue={rsInfo.signalValue} param_last_date={rsInfo.param_last_date}
                browserTime={browserTime} />
                <DmLink islink={islink} />
                </div>
            </div>
            {islink === 'Offline' ? (
                <div className='isConnectionLostCard'>
                    <h3 className='noDataDevice'>Нет данных</h3> 
                </div>
            ) : ( !isConnectionLost ? (
            <div className='rsInfoBody'>
            {rsInfo.typeRsDevice==='PLC' && 
                <div className='plcInfoBody'>   
                   <PrepDataPlc pumpsData={parameter} />
                </div>
            }
            {(rsInfo.typeRsDevice==='PCH_Instart' || 
                rsInfo.typeRsDevice==='PCH_ESQ' ||
                rsInfo.typeRsDevice==='PCH_ATV') &&
               <PrepDataPch pchData={parameter}/>
            }
            </div>) : ( 
                <div className='isConnectionLostCard'>
                    <h3 className='isConnectionName'>Нет связи с {rsInfo.typeRsDevice === 'PLC' ? 'ПЛК' : 'ПЧ'} по RS485</h3> 
                </div>
            )
                ) }
        </div>
    )
}